import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

const initialState = {
  entityLevelList: [],
  loading: false,
  error: '',
};

export const fetchEntityLevel = createAsyncThunk(
  'entitityLevel/fetchEntityLevel',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetEntityLevel();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: item.name,
          value: item.id,
        })) ?? [];

      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const entityLevelSlice = createSlice({
  name: 'entityLevel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntityLevel.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEntityLevel.fulfilled, (state, action) => {
        state.loading = false;
        state.entityLevelList = action.payload;
        state.error = '';
      })
      .addCase(fetchEntityLevel.rejected, (state, action) => {
        state.loading = false;
        state.entityLevelList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default entityLevelSlice.reducer;
